import { render, staticRenderFns } from "./IncidentReport.vue?vue&type=template&id=3ba17084"
import script from "./IncidentReport.vue?vue&type=script&lang=js"
export * from "./IncidentReport.vue?vue&type=script&lang=js"
import style0 from "./IncidentReport.vue?vue&type=style&index=0&id=3ba17084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports